import { useView } from "../../../../../app/components/propertiesPage/context/ViewContext";
import BrandedButton from "../../../../shadcn/components/custom/BrandedButton";
import { PDListSortByDropdown } from "./PDListSortByDropdown";

interface PropertyListHeaderViewPropsInterface {
  isFilterOpen?: boolean;
  title: string;
  totalCount?: number;
  onFilterToggle?: () => void;
  onSelectSortOption: (option: any) => void;
  sortByDropdownOptions: { label: string; value: string }[];
  isLoading?: boolean;
}

export const PropertyListHeaderView: React.FC<
  PropertyListHeaderViewPropsInterface
> = ({
  isFilterOpen = false,
  title = "Properties",
  totalCount = null,
  onFilterToggle,
  onSelectSortOption,
  sortByDropdownOptions,
  isLoading = false,
}) => {
  const { currentView, setCurrentView } = useView();
  return (
    <div className="py-2 sticky top-14 z-[12] bg-white border-b border-gray-200">
      <div className="flex flex-wrap items-center justify-between py-2 gap-2">
        <h1 className="text-md md:text-xl lg:text-2xl font-semibold text-gray-900">
          {title}
        </h1>

        <div className="flex gap-2 flex-wrap">
          <BrandedButton
            onClick={() => {
              setCurrentView("grid");
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            className={`px-3 py-1 rounded-md border text-sm hover:text-white ${
              currentView === "grid"
                ? "bg-brand-orange text-white border-brand-orange"
                : "text-black bg-white border-gray-300"
            }`}
          >
            Grid
          </BrandedButton>

          <BrandedButton
            onClick={() => {
              setCurrentView("list");
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            variant="primary"
            className={`px-3 py-1 rounded-md border hover:text-white text-sm ${
              currentView === "list"
                ? "bg-brand-orange text-white border-brand-orange"
                : "text-black bg-white border-gray-300"
            }`}
          >
            List
          </BrandedButton>

          <BrandedButton
            variant="primary"
            onClick={onFilterToggle}
            className={`px-3 py-1 rounded-md border border-gray-300 text-sm bg-white hover:text-white text-black ${
              isFilterOpen && "border-brand-orange"
            }`}
          >
            Filters
          </BrandedButton>
        </div>
      </div>

      <div className="flex gap-2 flex-wrap justify-between items-center border-t border-gray-200 py-2">
        <div className="text-xs text-gray-500 flex items-center gap-1">
          Showing
          <strong className="text-gray-800 inline-flex items-center justify-center">
            {isLoading ? (
              <span className="inline-block w-[0.9em] h-[0.9em] border-2 border-gray-300 border-t-gray-800 rounded-full animate-spin" />
            ) : (
              totalCount
            )}
          </strong>
          properties
        </div>
        <PDListSortByDropdown
          onSelectSortOption={onSelectSortOption}
          options={sortByDropdownOptions}
        />
      </div>
    </div>
  );
};
